/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import epApi from '../../api/ePCT.api';
import { pctCallbackTimeout } from '../../settings';
import { startApplicationLoading, stopApplicationLoading } from '../../redux/features/application/application.slice';
import { RoutePath } from '../../shared/enums/RoutePath';

export default function useEPIframe({ procedure }) {
  const dispatch = useDispatch();
  const [epURL, setEpURL] = useState();
  const [loadingError, setLoadingError] = useState(false);
  const history = useHistory();
  const editMatchRoute = useRouteMatch('/:procedure/ep/edit/:submissionId');
  const createMatchRoute = useRouteMatch('/:procedure/ep/online-filing');
  const { submissionId } = useParams();

  const saveSubmission = async (token, subId) => {
    try {
      await epApi.saveEP(token, subId);
    } catch (err) {
      console.log(err);
    }
  };

  const iframeListener = async (message) => {
    setTimeout(async () => {
      try {
        const event = JSON.parse(message.data);
        if (event.eventType === 'save-submission') {
          dispatch(startApplicationLoading());
          await saveSubmission(sessionStorage.getItem('hfsToken'), submissionId);
          dispatch(stopApplicationLoading());
          history.push(
            RoutePath.generateRoutePath(RoutePath.PROCEDURE_SEARCH, {
              procedure,
            }),
          );
        }
        if (event.eventType === 'close-iframe') {
          history.push(
            RoutePath.generateRoutePath(RoutePath.PROCEDURE_SEARCH, {
              procedure,
            }),
          );
        }
        // eslint-disable-next-line no-empty
      } catch (_) {}
    }, 500);
  };

  useEffect(() => {
    const handler = (event) => {
      if (event.data === 'closed') {
        dispatch(startApplicationLoading());
        setTimeout(() => {
          dispatch(stopApplicationLoading());
          history.push(
            RoutePath.generateRoutePath(RoutePath.PROCEDURE_SEARCH, {
              procedure,
            }),
          );
        }, pctCallbackTimeout);
      }
    };
    window.addEventListener('message', handler);

    (async function renderEpSection() {
      try {
        const iframeUrl = await epApi.iframeUrl();
        if (editMatchRoute) {
          dispatch(startApplicationLoading());
          const token = await epApi.editEP(null, submissionId);
          sessionStorage.setItem('hfsToken', token.token);
          setEpURL(`${iframeUrl}?token=${token.token}`);
          setLoadingError(false);
          dispatch(stopApplicationLoading());
        }

        if (createMatchRoute) {
          const { fileReference, paymentMethods, requestLanguage } = history.location.state.epCreationData;
          const epParams = {
            fileReference,
            paymentMethods,
            requestLanguage,
          };
          dispatch(startApplicationLoading());
          const token = await epApi.createEP(epParams);
          sessionStorage.setItem('hfsToken', token.token);
          setEpURL(`${iframeUrl}?token=${token.token}`);
          setLoadingError(false);
          dispatch(stopApplicationLoading());
        }
      } catch (err) {
        setLoadingError(true);
        dispatch(stopApplicationLoading());
      }
    })();

    return () => window.removeEventListener('message', handler);
  }, []);

  return { epURL, loadingError, submissionId, iframeListener };
}
